var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-chart"},[_c('div',{staticClass:"chart",style:(_vm.height?{height: _vm.height }:''),attrs:{"id":_vm.id}})])
}
var staticRenderFns = []

export { render, staticRenderFns }